import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

interface RequestAssignmentParams {
    individual_uuid: string;
}

const assignPodToAthlete = (
    organizationUuid: string,
    selectedPodUuid: string,
    params: RequestAssignmentParams,
): ReturnType => {
    return Request.post(
        `organizations/${organizationUuid}/pods/${selectedPodUuid}/assign-athlete`,
        params,
    );
};

export { assignPodToAthlete };
